import { useEffect } from 'react';

type PageType =
  | 'article-page'
  | 'category-page'
  | 'index-page'
  | 'generic-page'
  | 'search-page'
  | 'error-page';

/**
 * This just adds the page class to the body.
 * @param pageType the type of page
 */
function usePageClassName(pageType: PageType) {
  useEffect(() => {
    document.body.classList.remove(
      'article-page',
      'category-page',
      'index-page',
      'generic-page',
      'search-page',
      'error-page'
    );
    document.body.classList.add(pageType);
  }, [pageType]);
}

export default usePageClassName;
